import React from 'react';
import { ExternalLink, Gift, TrendingUp, Zap } from 'lucide-react';

const OffersSection = () => {
  const offers = [
    {
      id: 1,
      name: '32Red',
      url: 'https://www.32red.com',
      bonus: 'Get 150% up to £150 on your first deposit + 25 free spins',
      icon: <Gift className="w-8 h-8" />,
      gradient: 'from-brown-600 to-brown-800'
    },
    {
      id: 2,
      name: 'Highbet',
      url: 'https://www.highbet.co.uk/',
      bonus: 'Get 50 Free Spins on big bass splash',
      icon: <TrendingUp className="w-8 h-8" />,
      gradient: 'from-beige-400 to-brown-600'
    },
    {
      id: 3,
      name: 'PlayOJO',
      url: 'https://www.playojo.com',
      bonus: 'Get 50 Free Spins on 1st deposit',
      icon: <Zap className="w-8 h-8" />,
      gradient: 'from-brown-700 to-beige-600'
    }
  ];

  const OfferCard = ({ offer }) => (
    <div itemScope itemType="https://schema.org/Offer">
      <a
        href={offer.url}
        target="_blank"
        rel="noopener noreferrer nofollow sponsored"
        className="block glass-strong rounded-3xl p-8 hover:scale-105 transition-transform duration-300 group"
        itemProp="url"
      >
        <div className="flex flex-col items-center text-center mb-6">
          <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${offer.gradient} flex items-center justify-center text-white mb-4 group-hover:scale-110 transition-transform`}>
            {offer.icon}
          </div>
          <h3 className="text-3xl font-bold text-brown-900 mb-2" itemProp="name">{offer.name}</h3>
          <div className="w-16 h-1 bg-gradient-to-r from-brown-600 to-beige-400 rounded-full"></div>
        </div>
        <p className="text-brown-700 text-lg mb-6 leading-relaxed" itemProp="description">{offer.bonus}</p>
        <div className="flex items-center justify-center space-x-2 text-brown-700 font-semibold group-hover:text-brown-900 transition-colors">
          <span>Play at {offer.name}</span>
          <ExternalLink className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
        </div>
      </a>
    </div>
  );

  return (
    <section id="offers" className="py-20 px-4 bg-gradient-to-b from-beige-50 to-beige-100">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-brown-900 mb-4">
            Exclusive Casino Offers
          </h2>
          <p className="text-xl text-brown-700 max-w-2xl mx-auto">
            Hand-picked bonuses from the UK's most trusted casinos. Start playing with extra funds today.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-brown-600 to-beige-400 rounded-full mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {offers.map((offer) => (
            <OfferCard key={offer.id} offer={offer} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OffersSection;

